var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutopostText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 52,
    viewBox: "0 0 203 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Autopost",
    transform: "translate(3 41)",
    fill: "#0c0834",
    fontSize: 42,
    fontFamily: "Montserrat-SemiBoldItalic, Montserrat",
    fontWeight: 600,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Autopost"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopostText);
export default __webpack_public_path__ + "static/media/autopost-text.80e419303667246b1af78f4159197448.svg";
export { ForwardRef as ReactComponent };